/*
 * Copyright 2023 StarTree Inc.
 *
 * All rights reserved. Confidential and proprietary information of StarTree Inc.
 */

import { HeapProvider } from "@startree-ui/heap-provider";
import {
    ChatSupportProviderV1,
    useAuthProviderV1,
} from "@startree-ui/platform-ui";
import {
    getEnvironmentFromLocation,
    SentryProvider,
} from "@startree-ui/sentry-provider";
import React, { FunctionComponent } from "react";
import { getDataManagerUiVersion } from "../../utils/version/version.util";
import { useWorkspaceProviderStore } from "../workspace/store/workspace.store";

const ANALYTICS_APP_ID = "MTc3NTk1NTQzNQ==";
const INTERCOM_APP_ID = "YnhzNDMzZmU=";
const SENTRY_DSN =
    "aHR0cHM6Ly9lNDUzODJhMGZlNWMyYjNmNTUzMTdhMzU1OWIxZjMwOUBvNDUwNTQ4NDIwNzMyNTE4NC5pbmdlc3Quc2VudHJ5LmlvLzQ1MDU3NDYxMjQxMTE4NzI=";

export const AnalyticsAndChatProviderWrapper: FunctionComponent = ({
    children,
}) => {
    const { authUser } = useAuthProviderV1();
    const { selectedWorkspace } = useWorkspaceProviderStore((state) => ({
        selectedWorkspace: state.selectedWorkspace,
    }));

    return (
        <ChatSupportProviderV1
            appId={atob(INTERCOM_APP_ID)}
            email={authUser.email}
            nameOfUser={authUser.name}
            options={{
                verticalPadding: 96,
                // Show the widget in the middle.
                // The widget is 48 px tall
            }}
        >
            <SentryProvider
                environment={getEnvironmentFromLocation()}
                release={getDataManagerUiVersion()}
                sentryDSN={atob(SENTRY_DSN)}
                userEmail={authUser.email}
            />

            <HeapProvider
                appId={atob(ANALYTICS_APP_ID)}
                email={authUser.email}
                name={authUser.name}
                workspace={{
                    id: selectedWorkspace?.workspaceId,
                    name: selectedWorkspace?.workspaceName,
                }}
            />

            {children}
        </ChatSupportProviderV1>
    );
};
